'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = require('semantic-ui-react');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SENT_STATUS = 'SENT';

var BooleanStatusIcon = function BooleanStatusIcon(_ref) {
  var value = _ref.value;

  if (value) {
    return _react2.default.createElement(_semanticUiReact.Icon, { color: 'green', name: 'checkmark' });
  }
  return _react2.default.createElement(_semanticUiReact.Icon, { color: 'gray', name: 'minus' });
};

var BrokenInfluencer = function BrokenInfluencer(_ref2) {
  var name = _ref2.name;
  return _react2.default.createElement(
    _semanticUiReact.Table.Row,
    null,
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      { textAlign: 'center' },
      _react2.default.createElement(_semanticUiReact.Icon, { name: 'user' })
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      { textAlign: 'left' },
      _react2.default.createElement(
        'p',
        null,
        name
      ),
      _react2.default.createElement(
        'p',
        null,
        _react2.default.createElement(
          'strong',
          { style: { color: 'orange' } },
          'Broken influencer'
        )
      )
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      '-'
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      '-'
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      '-'
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      '-'
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      '-'
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      '-'
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      '-'
    )
  );
};

var AuthReportRow = function AuthReportRow(_ref3) {
  var discussion = _ref3.discussion;

  var organisation = _lodash2.default.find(discussion.organisations, 'influencer');
  var influencer = _lodash2.default.get(organisation, 'influencer');
  if (_lodash2.default.isNil(influencer)) {
    return _react2.default.createElement(BrokenInfluencer, discussion);
  }
  var facebookAuthorised = influencer.facebookAuthorised,
      instagramAuthorised = influencer.instagramAuthorised,
      youtubeAuthorised = influencer.youtubeAuthorised,
      twitterAuthorised = influencer.twitterAuthorised;

  var isAccepted = _lodash2.default.find(discussion.members, ['organisation.id', organisation.id]);
  var isInvited = _lodash2.default.find(discussion.invitations, function (inv) {
    return inv.organisation && inv.organisation.id === organisation.id && inv.status === SENT_STATUS;
  });

  var member = _lodash2.default.find(discussion.members, function (inv) {
    return inv && inv.organisation && inv.organisation.orgType === 'INFLUENCER';
  });

  return _react2.default.createElement(
    _semanticUiReact.Table.Row,
    { key: discussion.id },
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      { textAlign: 'center' },
      _react2.default.createElement(_semanticUiReact.Image, {
        avatar: true,
        verticalAlign: 'middle',
        src: influencer.thumbnail,
        size: 'mini'
      })
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      { textAlign: 'left' },
      _react2.default.createElement(
        'p',
        null,
        influencer.name
      ),
      _react2.default.createElement(
        'p',
        null,
        _react2.default.createElement(
          'strong',
          null,
          influencer.primarySocialHandle
        )
      )
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      { textAlign: 'center' },
      _react2.default.createElement(BooleanStatusIcon, { value: isAccepted || isInvited })
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      { textAlign: 'center' },
      _react2.default.createElement(BooleanStatusIcon, { value: isAccepted })
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      { textAlign: 'center' },
      _react2.default.createElement(BooleanStatusIcon, { value: facebookAuthorised })
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      { textAlign: 'center' },
      _react2.default.createElement(BooleanStatusIcon, { value: instagramAuthorised })
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      { textAlign: 'center' },
      _react2.default.createElement(BooleanStatusIcon, { value: youtubeAuthorised })
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      { textAlign: 'center' },
      _react2.default.createElement(BooleanStatusIcon, { value: twitterAuthorised })
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      { textAlign: 'center' },
      _react2.default.createElement(
        'p',
        null,
        isInvited && isInvited.email,
        member && member.email
      ),
      _react2.default.createElement(
        'p',
        null,
        isInvited && isInvited.link,
        member && _react2.default.createElement(
          'span',
          { style: { textDecoration: 'line-through' } },
          'processed'
        )
      )
    )
  );
};

AuthReportRow.propTypes = {
  discussion: _propTypes2.default.object.isRequired
};

BooleanStatusIcon.propTypes = {
  value: _propTypes2.default.any
};

BooleanStatusIcon.defaultProps = {
  value: null
};

exports.default = AuthReportRow;


//////////////////
// WEBPACK FOOTER
// ./node_modules/dyzio-shared-components/lib/reports/auth-report-row/index.js
// module id = 2209
// module chunks = 1